import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { AppServiceToken } from '../../../models/app.service.model';
import { CompanyToken } from '../../../models/company.model';

export interface AdminPageProps {};

type ContexType = {
  setRoute: React.Dispatch<React.SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppServiceToken | null,
  companyForUser: CompanyToken | null,
};

const AdminPage: React.FunctionComponent<AdminPageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser} = UseOutletContext()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser}}></Outlet>
  );
}

export function UseOutletContextAdmin() {
  return useOutletContext<ContexType>()
};

export default AdminPage;
